import { jsx } from "react/jsx-runtime";
import { useContext, useEffect } from "react";
import PropTypes from "prop-types";
import { useId } from "@reach/auto-id";
import "lodash/fp";
import "styled-components";
import "../../contexts/display-mode-context/display-mode-context.es.js";
import "../../contexts/global-edit-context/global-edit-context.es.js";
import { toastContext } from "../../contexts/toast-context/toast-context.es.js";
import "../../utils/is-valid-ref.es.js";
import "../../hooks/use-horizontal-scroll.es.js";
import "react-use-measure";
import "@juggle/resize-observer";
import "@reach/utils";
import "@reach/rect";
import "compute-scroll-into-view";
import { ToastImpl } from "./toast-impl.es.js";
const propTypes = {
  children: PropTypes.node,
  clickable: PropTypes.bool,
  duration: PropTypes.number,
  onDismiss: PropTypes.func,
  toasterId: PropTypes.string,
  variant: PropTypes.oneOf(["error", "feedback", "loading", "info", "success"])
};
const defaultProps = {
  children: void 0,
  clickable: false,
  duration: 0,
  onDismiss: void 0,
  toasterId: void 0,
  variant: void 0
};
const Toast = ({
  children,
  clickable,
  duration,
  onDismiss,
  toasterId,
  variant
}) => {
  const id = useId();
  const { setToast, removeToast } = useContext(toastContext);
  useEffect(() => {
    if (!id || !toasterId) {
      return;
    }
    setToast(toasterId, `toast-by-component__${id}`, {
      clickable,
      message: children,
      onDismiss,
      variant
    });
  }, [children, clickable, id, onDismiss, setToast, toasterId, variant]);
  useEffect(() => {
    if (!duration) {
      return void 0;
    }
    const timerId = setTimeout(onDismiss, duration);
    return () => {
      clearTimeout(timerId);
    };
  }, [onDismiss, duration]);
  useEffect(
    () => () => {
      if (toasterId && id) {
        removeToast(toasterId, `toast-by-component__${id}`);
      }
    },
    [removeToast, toasterId, id]
  );
  if (toasterId) {
    return null;
  }
  return /* @__PURE__ */ jsx(ToastImpl, { clickable, onClick: onDismiss, variant, children });
};
Toast.propTypes = propTypes;
Toast.defaultProps = defaultProps;
export {
  Toast
};
